import { Button } from '@/components/ui/Button';
import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

export interface FormActionsProps {
  primaryLabel?: string;
  onPrimary?: () => void;
  primaryLoading?: boolean;
  primaryDisabled?: boolean;
  primaryType?: 'button' | 'submit';
  onCancel?: () => void;
  cancelLabel?: string;
  onReset?: () => void;
  resetLabel?: string;
  children?: ReactNode;
  className?: string;
  /** Divider above the action row (default true). */
  bordered?: boolean;
}

/** Centered save/create actions for full-page inline forms. Do not use inside modals. */
export function FormActions({
  primaryLabel = 'Save',
  onPrimary,
  primaryLoading,
  primaryDisabled,
  primaryType = 'button',
  onCancel,
  cancelLabel = 'Cancel',
  onReset,
  resetLabel = 'Reset',
  children,
  className,
  bordered = true,
}: FormActionsProps) {
  return (
    <div className={cn('form-actions', bordered && 'form-actions--bordered', className)}>
      <div className="form-actions-inner">
        {onCancel ? (
          <Button type="button" variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
        ) : onReset ? (
          <Button type="button" variant="secondary" onClick={onReset}>
            {resetLabel}
          </Button>
        ) : null}
        {(onPrimary || primaryType === 'submit') && (
          <Button
            type={primaryType}
            onClick={onPrimary}
            loading={primaryLoading}
            disabled={primaryDisabled}
          >
            {primaryLabel}
          </Button>
        )}
        {children}
      </div>
    </div>
  );
}
